import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
// import '../../style/forms/formValidation/formValidation.less';

export default Form;
